import {
  FETCH_PROJECTS_USERS_DEVICES,
  CLEAR_PROJECT_DATA
} from '#action/types';

const defaultState = {
  parentProject: null,
  users: [],
  devices: [],
  projectDevices: [],
  projects: []
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_PROJECTS_USERS_DEVICES:
      return action.payload;
    case CLEAR_PROJECT_DATA:
      return defaultState;
    default:
      return state;
  }
};
